import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const NoDataState = () => {
  const navigate = useNavigate();

  const handleGoToCalculator = () => {
    navigate('/loan-calculator-dashboard');
  };

  const handleViewSampleReport = () => {
    // This will show the sample report with mock data
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-center max-w-lg p-8 bg-white rounded-lg shadow-elevated">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="FileText" size={32} className="text-primary" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mb-3">No Calculation Data Found</h2>
        <p className="text-gray-600 mb-6 leading-relaxed">
          It looks like you haven't created any loan calculations yet. To generate a preview report, 
          you'll need to first calculate a loan using our calculator.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="primary"
            iconName="Calculator"
            iconPosition="left"
            onClick={handleGoToCalculator}
            className="flex items-center justify-center"
          >
            Create Loan Calculation
          </Button>

          <Button
            variant="outline"
            iconName="Eye"
            iconPosition="left"
            onClick={handleViewSampleReport}
            className="flex items-center justify-center"
          >
            View Sample Report
          </Button>
        </div>

        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} className="text-blue-600 mt-0.5" />
            <div className="text-sm">
              <p className="font-medium text-blue-800 mb-1">Quick Start Guide:</p>
              <ul className="text-blue-700 space-y-1 text-left">
                <li>• Enter your loan amount, interest rate, and term</li>
                <li>• Click "Calculate" to generate your amortization schedule</li>
                <li>• Use the "Print Preview" button to view your report</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoDataState;